/**
 * Created by emanuele on 31/01/2017.
 */
import React from 'react';

const ShowOptionalField = ({ label, value }) => {

    if (value !== null && value !== '')
    {
        return <span><label>{label}</label>&nbsp;{value}</span>
    }
    else{
        return <span></span>
    }
}

export default ShowOptionalField;


/** WEBPACK FOOTER **
 ** ./src/components/ShowOptionalField.jsx
 **/